
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { fallbackRoute } from './routeDefinitions';
import { StandardRoutes } from './StandardRoutes';
import { LocationBennesGeographicRoutes, DemolitionGeographicRoutes } from './geographicLazyRoutes';
import { seoMetauxRoutes } from './seoRoutes';

const RouteRenderer: React.FC = () => {
  return (
    <Routes>
      {/* Standard routes */}
      {StandardRoutes()}

      {/* Geographic lazy-loaded routes */}
      {LocationBennesGeographicRoutes()}
      {DemolitionGeographicRoutes()}

      {/* SEO Metal routes */}
      {seoMetauxRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={<route.element />} />
      ))}

      {/* Fallback route */}
      <Route path={fallbackRoute.path} element={<fallbackRoute.element />} />
    </Routes>
  );
};

export default RouteRenderer;
